import { render, staticRenderFns } from "./SectionDetails.vue?vue&type=template&id=54b607d2&scoped=true"
import script from "./SectionDetails.vue?vue&type=script&lang=js"
export * from "./SectionDetails.vue?vue&type=script&lang=js"
import style0 from "./SectionDetails.vue?vue&type=style&index=0&id=54b607d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b607d2",
  null
  
)

export default component.exports